import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import BaseCheckoutLayout from './base-checkout-layout';
import Layout from '../layout';
import APP_ROUTES from '../../constants/app-routes';

class PaymentRedsysRedirectKo extends Component {
    constructor(props) {
        super(props);
        document.title = this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
    }

    /* Render this step only if order is present and in a valid checkout state. */
    componentWillMount() {
        const { order } = this.props;
        this.props.addRedsysPaymentError(true);
        this.props.history.push(APP_ROUTES.checkout.paymentPageRoute);
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps) {
        if (this.props.locale !== prevProps.locale) {
            document.title = this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
        }
    }

    render() {
        const { order } = this.props;

        return (
            <Layout>
                <BaseCheckoutLayout
                    hasExtraTimeCheckout={this.props.hasExtraTimeCheckout}
                    gracePeriod={this.props.gracePeriod}
                    locale={this.props.locale.currentLocale}
                    currentStep="payment"
                    checkoutSteps={order.checkout_steps || []}
                    order={this.props.order}
                >
                    <div />
                </BaseCheckoutLayout>
            </Layout>
        );
    }
}

export default injectIntl(withRouter(PaymentRedsysRedirectKo));



/** WEBPACK FOOTER **
 ** ./src/components/checkout-steps/payment-redsys-redirect-ko.jsx
 **/